import { t } from "@travily/i18n";
import individualIllustration from "@ui/assets/illustrations/individual-animated.webp";
import { Wizard } from "@ui/components/Wizard";
import { WizardTextArea } from "@ui/components/WizardTextArea";
import type { ReactNode } from "react";

const COLOR = "purple" as const;

export interface ConnectStepViewProps {
  /** Current stage, 1-indexed, for the progress bar. */
  currentStage: number;
  /** Total stages driving the progress bar. */
  totalStages: number;
  /** Back handler; omit on the first stage to hide the back affordance. */
  onBack?: () => void;
  /** Top-bar tertiary actions (e.g. "Questions?", "Save and finish later"). */
  topBarActions: ReactNode;
  /** Primary "Continue" handler. */
  onPrimary: () => void;
  /** Whether the primary button shows its pending state. */
  primaryPending: boolean;
  /** Current socials value for the textarea. */
  socials: string;
  /** Field error message; when present the textarea renders invalid. */
  error?: string;
  /** Fires on textarea change with the new value. */
  onSocialsChange: (value: string) => void;
}

export const ConnectStepView = ({
  currentStage,
  totalStages,
  onBack,
  topBarActions,
  onPrimary,
  primaryPending,
  socials,
  error,
  onSocialsChange,
}: ConnectStepViewProps) => {
  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage
        illustration={<img alt="" aria-hidden="true" src={individualIllustration} />}
        heading={t("web.founding_members.creator.steps.individual.connect.show.title")}
      >
        <div className="w-full max-w-[600px]">
          <WizardTextArea
            color={COLOR}
            errorMessage={error}
            isInvalid={Boolean(error)}
            isLabelHidden
            label={t("web.founding_members.creator.steps.individual.connect.show.label")}
            onChange={onSocialsChange}
            placeholder={t("web.founding_members.creator.steps.individual.connect.show.placeholder")}
            rows={4}
            value={socials}
          />
        </div>
      </Wizard.Stage>
    </Wizard>
  );
};
